// SCE TOU-8 Time-Related Demand (TRD) windows.
//
// MIRRORS the Data Center webapp's TARIFF_PRESETS.sce_tou8_d
// (features/analytics/siteWizard/tariffPresets.js): its two time_of_use
// demandCharges rows carry exactly these months / hourStart / hourEnd, and
// useAddMicrogrid there derives its TRD windows from that preset. Prod has
// no analytics layer yet, so the same numbers live here; when the analytics
// layer lands, re-point useAddMicrogrid at TARIFF_PRESETS.sce_tou8_d and
// delete this file. Nothing under features/microgrids/ may import from
// analytics/ or planner/ until then.
//
// Summer on-peak TRD: Jun-Sep, weekdays 16-21 (4-9 pm).
// Winter mid-peak TRD: Oct-May, weekdays 16-21 (4-9 pm).
export const SUMMER_TRD_MONTHS = [6, 7, 8, 9];
export const WINTER_TRD_MONTHS = [1, 2, 3, 4, 5, 10, 11, 12];
export const TRD_HOUR_START = 16;
export const TRD_HOUR_END = 21;
